import React, { memo } from 'react';
import classNames from 'classnames';

import { getOriginalIn } from '../../../utils/ChangeSpy';
import { ContactActivities } from '../ContactActivities';
import { ContactInfo } from '../ContactInfo';
import { Card } from '../../helpers/Card';
import { ResizableColumns } from '../../helpers/ResizableColumns';
import { ResizableSection } from '../../helpers/ResizableSection';

import style from './style.module.css';

const ContactTopPartComponent = ({
  onBlurInfo,
  onSubmitInfo,
  contactInfo,
  suffixSuggest,
  contactEventProps,
  onChange,
}) => (
  <div
    className={classNames(style.host, 'container', {
      [style.doNotMail]: getOriginalIn(contactInfo, 'doNotMail'),
    })}
  >
    <ResizableSection storageKey="contactTopHeight">
      <ResizableColumns storageKey="contactInfoWidth">
        <Card as="section" className={style.infoCard}>
          <ContactInfo
            info={contactInfo}
            onBlur={onBlurInfo}
            onChange={onChange}
            onSubmit={onSubmitInfo}
            suffixSuggest={suffixSuggest}
          />
        </Card>

        <Card as="section" className={style.activitiesCard} flush>
          <div className={classNames(style.activities, 'table-responsive flexWrapper')}>
            <ContactActivities {...contactEventProps} />
          </div>
        </Card>
      </ResizableColumns>
    </ResizableSection>
  </div>
);

/** Contact top part component. */
export const ContactTopPart = memo(ContactTopPartComponent);
